import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { apiColletions } from "src/app/core/constants/api_collection";
import { AccessibilityAndCustomPrice } from "src/app/core/constants/constants";

@Injectable({
  providedIn: "root"
})
export class AccessibilityService {
  constructor(private readonly apiService: ApiService) {}

  getAccessibilityList(parameters = {}, pageType: number = AccessibilityAndCustomPrice.ACCESSIBILITY): Observable<boolean> {
    let url: string;
    if (pageType === AccessibilityAndCustomPrice.ACCESSIBILITY) {
      url = apiColletions.accessibility;
    } else {
      url = apiColletions.customPrice;
    }
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: url, parameters: parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
